export default __webpack_public_path__ + "static/media/img_step_hami03.76ffbda9.png";